import { createBackgroundLoaderContext } from "contexts";
import { PartnerSchool } from "models";

export const PartnerSchoolContext = createBackgroundLoaderContext<PartnerSchool>();
